import React from 'react'
import ErrorBoundary from '@fs/zion-error-boundary'
import Elevation from '@fs/zion-ui/elevation'
import FSLogo from '../shared/components/FSLogo/FSLogo'
import { shadowCss, headerStyle } from '../Header2019/components/Header2019/Header2019'

/**
 * A minimal header component that displays only the FamilySearch logo. This component is designed for simple layouts where only brand identification is needed without additional navigation elements.
 *
 * ## Usages
 *
 * Used in `hf-inj-react` to display the FamilySearch logo in a simple header format for sites that don't require our navigation and/or authentication
 * For example at https://libcat.familysearch.org/?browseCategory=familysearch_new_books
 */
export default function LogoOnlyHeader() {
  return (
    <ErrorBoundary>
      <Elevation className={shadowCss} z={0}>
        <header className={headerStyle}>
          <FSLogo useBaseUrl />
        </header>
      </Elevation>
    </ErrorBoundary>
  )
}
